import { ChangeDetectionStrategy, Component, NO_ERRORS_SCHEMA, ViewChild } from '@angular/core';
import { DeviceBaseComponent } from '../../device-base/device-base.component';
import { NgIf, NgClass } from '@angular/common';

@Component({
  selector: 'app-yealink-t54',
  templateUrl: './yealink-t54.component.html',
  styleUrls: ['../../device-base/device-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DeviceBaseComponent, NgIf, NgClass],
  schemas: [NO_ERRORS_SCHEMA],
})
export class YealinkT54Component {
  @ViewChild('base') base!: DeviceBaseComponent;

  public readonly buttonsLimit = 27;
}
